module.exports = __webpack_public_path__ + "static/media/price-management-icon.5388ca6e.svg";